module.exports = __webpack_public_path__ + "static/media/rb_logo_assets_fyt.b608fea7.zip";